import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SivaInnovationFundsDto } from 'src/api/v2';
import InputWrapper from 'src/components/Form/InputWrapper';
import { formatCurrencySimple } from 'src/utils/FormatValue';
import { requiredI18n } from 'src/utils/validation';

type Props = {
  editMode: boolean;
  value: keyof SivaInnovationFundsDto;
  form: UseFormReturn<SivaInnovationFundsDto, any>;
  clusterEsaData: SivaInnovationFundsDto | undefined;
};

const TogglableEditCell = ({ editMode, value, form, clusterEsaData }: Props) => {
  const { t: tError } = useTranslation('error');

  return editMode ? (
    <InputWrapper
      {...form.register(value, {
        required: requiredI18n(tError),
      })}
      error={form.formState.errors[value]?.message}
      className="margin--0"
    />
  ) : (
    <>{clusterEsaData && clusterEsaData[value] ? formatCurrencySimple(clusterEsaData[value]!) : ''}</>
  );
};

export default TogglableEditCell;
